import React from 'react'
import { Testimonial } from '../../components/Testimonial/index'
import { ITestimonialModalProps } from './'
import { LegacyColor, mq } from 'marketing-site/src/library/utils'

export const TestimonialModal: React.FC<ITestimonialModalProps> = (props) => {
  return (
    <>
      <Testimonial {...props} version="testimonial--modal" />

      <style jsx global>
        {`
          .testimonial.testimonial--modal {
            width: 100%;
            max-width: 49.5rem;
            padding: 3.5rem 2.5rem 3rem;
            overflow-y: auto;
            background: none;

            &:after {
              display: none;
            }

            .testimonial-content {
              grid-template-columns: 100%;
              grid-row-gap: 1.5rem;
            }

            .quote-and-details-block {
              grid-column: 1;
              grid-row: 2/3;
            }

            .modal-name {
              display: block;

              span {
                font-size: 1.625rem;
              }
            }

            .modal-jobTitle {
              color: ${LegacyColor.UIGray};
            }

            .quote {
              padding-bottom: 0;
              margin-top: 1.5rem;

              .rich-text p {
                font-size: 1rem;
                line-height: 1.5;
                text-align: left;

                &:before,
                &:after {
                  display: none;
                }

                &:first-child {
                  text-indent: 0;
                }
              }
            }

            .details-wrapper {
              display: none;
            }

            .image-block {
              grid-column: 1;
              grid-row: 1/2;
              padding-bottom: 0;
              width: 15rem;
              max-width: 100%;
              justify-self: center;
              align-self: start;

              picture {
                width: 100%;
                padding-bottom: 100%;
                margin: 0 auto;
                border-radius: 7.5rem;
                overflow: hidden;
                position: relative;
              }

              .profile-image {
                position: absolute;
                height: 100%;
                object-fit: cover;
              }
            }
          }

          @media (${mq.tablet}) {
            .testimonial.testimonial--modal {
              padding: 3.5rem 3rem 3rem;

              .testimonial-content {
                grid-template-columns: auto auto;
                grid-column-gap: 2.5rem;
              }

              .quote-and-details-block {
                grid-column: 2/3;
                grid-row: 1;
              }

              .quote {
                margin-top: 2rem;
              }

              .image-block {
                grid-column: 1/2;
                width: 11.25rem;
              }
            }
          }

          @media (${mq.desktop}) {
            .testimonial.testimonial--modal {
              .image-block {
                width: 15rem;
              }
            }
          }

          @media (${mq.desktopLg}) {
            .testimonial.testimonial--modal {
              padding: 3.5rem 3.5rem 3rem;

              .testimonial-content {
                grid-template-columns: auto auto;
                grid-column-gap: 3rem;
              }
            }
          }
        `}
      </style>
    </>
  )
}
